import axios from 'axios'
import router from './router/index'

const axiosConfig = () => {
  const token = localStorage.getItem('token');

  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }

  // Agregar el token CSRF si está presente en la página HTML
  const csrfToken = document.querySelector('meta[name="csrf-token"]');
  if (csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.getAttribute('content');
  }
  // Manejo de errores si el token es inválido o ha expirado
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Token inválido o expirado, redirige a la página de inicio de sesión
        router.push({ name: 'Login' });
      }
      return Promise.reject(error);
    }
  );
};

export default axiosConfig;